<template>
  <div>
    <b-overlay :show="busy" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.saving") }}...
          </strong>
        </div>
        <div v-else-if="isLoading" class="text-center p-4 text-light rounded">
          <b-spinner
            style="width: 3rem; height: 3rem"
            variant="primary"
            class="mr-1"
            label="Large Spinner"
          ></b-spinner>
          <strong class="title-freight pt-1">
            {{ $t("button.loading") }}...
          </strong>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        ></div>
      </template>
    </b-overlay>

    <b-modal
      ref="dept-manage"
      size="md"
      hide-footer
      :title="locals('dept.detail')"
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-row class="pt-1">
        <b-col sm="12" class="text-left">
          <b-form-group
            label-for="i-dept-code"
            :label="locals('dept.code')"
            class="title-freight-require"
          >
            <b-form-input id="i-dept-code" v-model="form.strDeptCode" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-form-group
            label-for="i-dept-name"
            label="ชื่อแผนก (ภาษาไทย)"
            class="title-freight-require"
          >
            <b-form-input id="i-dept-name" v-model="form.strDeptName" />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label-for="i-dept-name-en"
            label="Department Name (EN)"
            class="title-freight-require"
          >
            <b-form-input id="i-dept-name-en" v-model="form.strDeptNameEN" />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <label for="i-noteremark" class="title-freight">
            {{ $t("inquiry.remark") }}</label
          >
          <b-form-textarea
            id="i-noteremark"
            placeholder=""
            rows="3"
            v-model="form.strRemark"
            maxlength="255"
          />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col class="d-flex justify-content-center demo-inline-spacing">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="success"
            class="mr-1 btn-fixed-width"
            pill
            @click="onSubmit"
          >
            <font-awesome-icon icon="fa-solid fa-save" />
            {{ $t("button.save") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="submit"
            class="mr-1 btn-fixed-width"
            variant="outline-warning"
            pill
            @click="hideModal"
          >
            {{ $t("button.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-card title="Department Master">
      <b-row>
        <b-col md="12">
          <div class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(0, 207, 232, 0.15)'"
              class="custom-add"
              @click="onAdd"
              pill
            >
              <feather-icon icon="PlusIcon" class="mr-50" />
              <span class="align-middle">{{ $t("button.new") }}</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-2">
        <b-col md="3">
          <b-form-group
            label-for="i-code"
            class="title-freight"
            :label="locals('dept.code')"
          >
            <b-form-input
              id="i-code"
              v-model="dataFilter.strDeptCode"
              maxlength="100"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            label-for="i-origin"
            class="title-freight"
            label="ชื่อแผนก (ภาษาไทย)"
          >
            <b-form-input
              id="i-origin"
              v-model="dataFilter.strDept"
              maxlength="100"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            label-for="i-origin"
            class="title-freight"
            label="Department Name (EN)"
          >
            <b-form-input
              id="i-origin"
              v-model="dataFilter.strDeptEN"
              maxlength="100"
            />
          </b-form-group> </b-col
      ></b-row>
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            class="mr-1 custom-search btn-fixed-width"
            pill
            @click="onSearch"
          >
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.search") }}</span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            variant="outline-secondary"
            class="mr-1 btn-fixed-width"
            pill
            @click="onClear"
          >
            <feather-icon icon="RefreshCwIcon" class="mr-50" />
            <span class="align-middle">{{ $t("button.clear") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-card :title="locals('dept.detail')">
      <b-row class="pt-2">
        <b-col md="12">
          <vue-good-table
            :columns="columns"
            :rows="rows"
            :search-options="{
              enabled: false,
            }"
            :pagination-options="{
              enabled: true,
              perPage: pageLength,
            }"
            styleClass="vgt-table condensed"
          >
            <!-- Slot: Table Column -->
            <template slot="table-column" slot-scope="props">
              <span v-if="props.column.label === 'Action'" class="text-nowrap">
                {{ $t("inquiry.action") }}
              </span> 
               <span
                v-else-if="props.column.label === 'รหัสแผนก'"
                class="text-nowrap"
              >
                {{ $t("dept.code") }}
              </span>
              <span
                v-else-if="props.column.label === 'ผู้สร้าง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.create_by") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่สร้าง'"
                class="text-nowrap"
              >
                {{ $t("inquiry.create_date") }}
              </span>
              <span
                v-else-if="props.column.label === 'ผู้แก้ไข'"
                class="text-nowrap"
              >
                {{ $t("inquiry.update_by") }}
              </span>
              <span
                v-else-if="props.column.label === 'วันที่แก้ไข'"
                class="text-nowrap"
              >
                {{ $t("inquiry.update_date") }}
              </span>
              <span v-else>
                {{ props.column.label }}
              </span>
            </template>
            <template slot="table-row" slot-scope="props">
              <!-- Column: Action -->
              <span v-if="props.column.field === 'action'">
                <div class="text-center">
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-warning"
                    class="btn-icon rounded-circle mr-1"
                    v-b-tooltip.hover.v-warning
                    title="Edit"
                    @click="onEdit(props.index, props.row.id)"
                  >
                     <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                    variant="outline-danger"
                    class="btn-icon rounded-circle"
                    v-b-tooltip.hover.v-danger
                    title="Delete"
                    @click="onDelete(props.index, props.row.id)"
                    disabled
                  >
                    <font-awesome-icon icon="fa-solid fa-trash" />
                  </b-button>
                </div>
              </span>
              <!-- Column: Status -->
              <span v-else-if="props.column.field === 'strStatus'">
                <div class="text-center">
                  <b-badge :variant="statusVariant(props.row.strStatus)">
                    {{ props.row.strStatus }}
                  </b-badge>
                </div>
              </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
              <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                  <span class="text-nowrap"> Showing 1 to </span>
                  <b-form-select
                    v-model="pageLength"
                    :options="['10', '20', '50', '100']"
                    class="mx-1"
                    @input="
                      (pageLength) =>
                        props.perPageChanged({
                          currentPerPage: pageLength,
                        })
                    "
                  />
                  <span class="text-nowrap">
                    of {{ props.total }} entries
                  </span>
                </div>
                <div>
                  <b-pagination
                    :value="1"
                    :total-rows="props.total"
                    :per-page="pageLength"
                    first-number
                    last-number
                    align="right"
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mt-1 mb-0"
                    @input="
                      (pageLength) =>
                        props.pageChanged({
                          currentPage: pageLength,
                        })
                    "
                  >
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
              </div>
            </template>
          </vue-good-table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BPagination,
  BBadge,
  BFormSelect,
  BOverlay,
  BSpinner,
  VBTooltip,
  VBModal,
} from "bootstrap-vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";

import Service from "@/@API/cDropdown";
import ReqService from "@/@API/cRequest";

export default {
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BCard,
    BInputGroup,
    vSelect,
    BInputGroupAppend,
    BButton,
    flatPickr,
    VueGoodTable,
    BPagination,
    BBadge,
    BFormSelect,
    BOverlay,
    BSpinner,
    VBTooltip,
    VBModal,
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        Draft: "light-info",
        DRAFT: "light-info",
        Submit: "light-success",
        SUBMIT: "light-success",
        Canceled: "light-danger",
      };
      return (table_status) => statusColor[table_status];
    },
  },
  data() {
    return {
      busy: true,
      processing: false,
      isLoading: true,
      form: {},
      dataFilter: {},
      TestOptions: [
        {
          intDsId: 1,
          strDsDesc: "TEST",
        },
        {
          intDsId: 99,
          strDsDesc: "อื่น ๆ",
        },
      ],
      table_status: [
        {
          0: "Draft",
          1: "DRAFT",
          2: "Submit",
          3: "SUBMIT",
          4: "Canceled",
        },
        {
          0: "light-info",
          1: "light-info",
          2: "light-success",
          3: "light-success",
          4: "light-danger",
        },
      ],
      pageLength: 20,
      dir: false,
      codeColumnSearch: "",
      columns: [
        {
          label: "Action",
          field: "action",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "รหัสแผนก",
          field: "strDeptCode",
          width: "150px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ชื่อแผนก",
          field: "strDeptName",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "Department Name",
          field: "strDeptNameEN",
          width: "200px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้สร้าง",
          field: "strCreatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่สร้าง",
          field: "datCreatedDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "ผู้แก้ไข",
          field: "strUpdatedBy",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "วันที่แก้ไข",
          field: "datUpdatedDateDMY",
          width: "180px",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      rows: [],
    };
  },
  mounted() {
    this.onClear();
  },
  methods: {
    getDefault() {},
    onSearch() {
      this.dataFilter = {};

      this.busy = true;
      this.isLoading = true;
      ReqService.getSearchDepartment(this.dataFilter)
        .then((response) => {
          console.log(response.data);
          this.busy = false;
          this.isLoading = false;
          let lang = localStorage.getItem("lang");
          this.rows = response.data;
          this.rows.forEach((q) => {
            q.datCreatedDateDMY = q.datCreatedDate
              ? moment(q.datCreatedDate).format("DD/MM/YYYY HH:mm")
              : null;
            q.datUpdatedDateDMY = q.datUpdatedDate
              ? moment(q.datUpdatedDate).format("DD/MM/YYYY HH:mm")
              : null;
          });
        })
        .catch((error) => {
          this.busy = false;
          this.isLoading = false;
          console.log("error", error);
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onAdd() {
      this.form = {
        intDeptId: -1,
        strDeptCode: "",
        strDeptName: "",
        strDeptNameEN: "",
        strRemark: "",
      };
      this.$refs["dept-manage"].show();
    },
    onEdit(index, Id) {
      this.form = {
        intDeptId: -1,
        strDeptCode: "",
        strDeptName: "",
        strDeptNameEN: "",
        strRemark: "",
      };
      this.form = this.rows[index];

      this.$refs["dept-manage"].show();
    },
    hideModal() {
      this.$refs["dept-manage"].hide();
    },
    onSubmit() {
      let lang = localStorage.getItem("language");

      let ifcomp = true;
      let errorsmsg = "";

      if (
        !(
          this.form.strDeptCode == "" ||
          this.form.strDeptCode == null ||
          this.form.strDeptName == null ||
          this.form.strDeptName == "" ||
          this.form.strDeptNameEN == null ||
          this.form.strDeptNameEN == ""
        )
      ) {
        if (this.form.intDeptId == null || this.form.intDeptId == "") {
          this.form.intDeptId = -1;
        }
        if (this.form.strRemark == null || this.form.strRemark == "") {
          this.form.strRemark = "-";
        }

        let b1 = "Confirm";
        let b2 = "Cancel";
        let text = "Confirm Save Department";

        if (lang == "th_TH") {
          b1 = "ยืนยัน";
          b2 = "ยกเลิก";
          text = "ยืนยันการบันทึกข้อมูลแผนก";
        }

        this.$bvModal
          .msgBoxConfirm(text, {
            title: text,
            size: "sm",
            modalClass: "modal-success",
            okVariant: "success",
            okTitle: b1,
            cancelTitle: b2,
            cancelVariant: "outline-warning",
            hideHeaderClose: false,
            //centered: true,
          })
          .then((value) => {
            if (value) {
              this.$refs["dept-manage"].hide();
              this.onSave();
            }
          });
      } else {
        let message = "";
        if (this.form.strDeptCode == "" || this.form.strDeptCode == null) {
          if (lang == "th_TH") {
            message = message + "- รหัสแผนก ,";
          } else {
            message = message + "- Department Code,";
          }
        }
        if (this.form.strDeptName == null || this.form.strDeptName == "") {
          if (lang == "th_TH") {
            message = message + "- ชื่อแผนก ,";
          } else {
            message = message + "- ชื่อแผนก (TH) ,";
          }
        }
        if (this.form.strDeptNameEN == null || this.form.strDeptNameEN == "") {
          if (lang == "th_TH") {
            message = message + " Department Name ";
          } else {
            message = message + " Department Name (EN) ";
          }
        }
        let titlemsg = "Please Fill in below details ";
        let alertmsg = "Please Select ";
        if (lang == "th_TH") {
          alertmsg = "กรุณาเลือก";
          titlemsg = "กรอกข้อมูลให้ครบถ้วน ";
        }
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: titlemsg,
              icon: "AlertCircleIcon",
              variant: "danger",
              text: alertmsg + message,
            },
          },
          {
            position: "top-center",
            timeout: 10000,
          }
        );
      }
    },
    onSave() {
      let lang = localStorage.getItem("language");

      this.busy = true;
      this.processing = true;

      var dataSave = {
        headerGrid: this.form,
        intRequestId: this.form.intDeptId,
        status: "",
      };
      console.log("dataSave", dataSave);
      let formData = new FormData();
      formData.append("strJson", JSON.stringify(dataSave));

      ReqService.saveDepartment(formData)
        .then((response) => {
          if (response.data == "Error") {
            this.busy = false;
            this.processing = false;
            this.$refs["dept-manage"].show();
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Something was wrong",
                  icon: "FrownIcon",
                  variant: "danger",
                  text: response.data,
                },
              },
              {
                position: "top-center",
              }
            );
          } else {
            this.onSearch();
            let compmsg = "Save Completed";
            if (lang == "th_TH") {
              compmsg = "บันทึกสำเร็จ";
            }
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: compmsg,
                  icon: "CheckIcon",
                  variant: "success",
                  text: response.data.message,
                },
              },
              {
                position: "top-center",
              }
            );
          }
        })
        .catch((error) => {
          this.busy = false;
          this.processing = false;
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Something was wrong",
                icon: "FrownIcon",
                variant: "danger",
                text: "Something was wrong : " + error,
              },
            },
            {
              position: "top-center",
            }
          );
        });
    },
    onDelete(index, Id) {
      let lang = localStorage.getItem("language");

      let tttitle = "Confirm Delete";
      let msg = "Do you want to delete this Department?";
      let b1 = "Delete";
      let b2 = "Close";

      if (lang == "th_TH") {
        tttitle = "ยืนยันการลบ";
        msg = "คุณต้องการยืนยันลบแผนกนี้ใช่หรือไม่ ?";
        b1 = "ลบ";
        b2 = "ปิด";
      }
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: tttitle,
          size: "sm",
          modalClass: "modal-danger",
          okVariant: "danger",
          okTitle: b1,
          cancelTitle: b2,
          cancelVariant: "outline-warning",
          hideHeaderClose: false,
          //centered: true,
        })
        .then((value) => {
          console.log(value);
          if (value) {
            this.busy = true;
            this.processing = true;
            ReqService.getResponseDeleteDepartment({ intDeptId: Id })
              .then((response) => {
                this.busy = false;
                this.processing = false;
                if (
                  response.data == "ไม่พบแผนก" ||
                  response.data == "ไม่สามารถลบได้"
                ) {
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "Something was wrong",
                        icon: "FrownIcon",
                        variant: "danger",
                        text: response.data,
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                } else {
                  this.rows.splice(index, 1);
                  this.$toast(
                    {
                      component: ToastificationContent,
                      props: {
                        title: "ลบข้อมูล",
                        icon: "XIcon",
                        variant: "success",
                        text: "ลบสำเร็จ",
                      },
                    },
                    {
                      position: "top-center",
                    }
                  );
                }
              })
              .catch((error) => {
                console.log("error", error);
                this.$toast(
                  {
                    component: ToastificationContent,
                    props: {
                      title: "Something was wrong",
                      icon: "FrownIcon",
                      variant: "danger",
                      text: "Something was wrong : " + error,
                    },
                  },
                  {
                    position: "top-center",
                  }
                );
              });
          }
        });
    },
    onClear() {
      this.dataFilter = {
        strDeptEN: "",
        strDept: "",
        strDeptCode: "",
      };
      this.onSearch();
    },
    locals(key) {
      return this.t(key);
    },
  },
};
</script>

<style lang="scss">
@import "../../@core/scss/vue/libs/vue-select.scss";
@import "../../@core/scss/vue/libs/vue-flatpicker.scss";
@import "../../@core/scss/vue/libs/vue-good-table.scss";
</style>
